import { SessionContextService } from "./../../../context/session-context.service";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { Message } from "../../../../../../shared-components/src/lib/models/message.model";
import { SessionService } from "../../../services/session.service";

import { TranslateService } from "@ngx-translate/core";
import { SpinnerService } from "shared-components";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
})
export class ChangePasswordComponent implements OnInit {
  public changePasswordForm: UntypedFormGroup;
  public showError = false;
  public mensajes = new Array<Message>();
  public showOPassword: boolean;
  public showNPassword: boolean;
  public showRNPassword: boolean;

  @Input() email: string;
  @Input() guid: string;
  @Input() recovery?: boolean;
  @Output() closeModal = new EventEmitter<boolean>();
  @Output() closeOptions = new EventEmitter<boolean>();
  @Output() pushMessage = new EventEmitter<object>();

  constructor(
    private _fb: UntypedFormBuilder,
    private readonly _sessionService: SessionService,
    private readonly _sessionContext: SessionContextService,
    private readonly _spinnerService: SpinnerService,
    private readonly _translate: TranslateService,
    public router: Router
  ) {}

  ngOnInit() {
    this.changePasswordForm = this._fb.group({
      oldPassword: this.recovery ? [""] : ["", Validators.required],
      newPassword: ["", Validators.required],
      repeatNewPassword: ["", Validators.required],
    });
  }

  public changePassword() {
    this.showError = this.changePasswordForm.invalid;
    if (this.changePasswordForm.valid) {
      if (
        this.changePasswordForm.get("newPassword").value ===
        this.changePasswordForm.get("repeatNewPassword").value
      ) {
        this.mensajes = [];
        this._spinnerService.showSpinner();
        if (this.recovery) {
          const credentials = {
            userName: this.email,
            password: this.changePasswordForm.get("newPassword").value,
            guid: this.guid,
          };
          this._sessionService
            .passwordRecoveryReset(credentials)
            .toPromise()
            .finally(() => {
              this._spinnerService.hideSpinner();
            })
            .then(
              (resp) => {
                this.showError = true;
                this.mensajes.push({
                  class: "success",
                  message: "session.success.changePassword",
                });
              },
              (error) => {
                this.showError = true;
                if (error.status === 420) {
                  switch (error.error.ApiErrorCode) {
                    case 1027:
                      const errorsDescription =
                        error.error.LsApiErrorCodeAsociados.map((a) =>
                          this._translate.instant(`ApiErrors.errorApi_${a}`)
                        );
                      this.mensajes.push({
                        class: "error multiline",
                        message: errorsDescription,
                      });
                      break;
                    default:
                      this.mensajes.push({
                        class: "error",
                        message: "global.error.noResponse",
                      });
                      break;
                  }
                } else {
                  this.mensajes.push({
                    class: "error",
                    message: "global.error.noResponse",
                  });
                }
              }
            );
        } else {
          const credentials = {
            userName: this._sessionContext.sessionUser.userName,
            oldPassword: this.changePasswordForm.get("oldPassword").value,
            newPassword: this.changePasswordForm.get("newPassword").value,
          };
          this._sessionService
            .changeCurrentPassword(credentials)
            .toPromise()
            .finally(() => {
              this._spinnerService.hideSpinner();
            })
            .then(
              (resp) => {
                this.pushMessage.emit({
                  class: "success",
                  message: "session.success.changePassword",
                });
                this.closeOptions.emit(false);
                this.closeModal.emit(false);
              },
              (error) => {
                this.showError = true;
                if (error.status === 420) {
                  switch (error.error.ApiErrorCode) {
                    case 1027:
                      const errorsDescription =
                        error.error.LsApiErrorCodeAsociados.map((a) =>
                          this._translate.instant(`ApiErrors.errorApi_${a}`)
                        );
                      this.mensajes.push({
                        class: "error",
                        message: errorsDescription,
                      });
                      break;
                    default:
                      this.mensajes.push({
                        class: "error",
                        message: "global.error.noResponse",
                      });
                      break;
                  }
                } else if (error.status === 400) {
                  this.mensajes.push({
                    class: "error",
                    message: "global.error.passwordNoRequisitos",
                  });
                } else {
                  this.mensajes.push({
                    class: "error",
                    message: "global.error.noResponse",
                  });
                }
              }
            );
        }
      } else {
        this.showError = true;
        this.mensajes.push({
          class: "error",
          message: "session.error.noSamePassword",
        });
      }
    } else {
      this.showError = true;
      this.mensajes.push({ class: "error", message: "global.error.required" });
    }
  }
}
